import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useFetchContestDetails from '../hooks/useFetchContestDetails';
import ContestDetails from '../details/ContestDetails';
// Import Completed Table/Team components (adjust paths/names as needed when created)
import EntrantsTeamsPokerCompleted from './EntrantsTeams/EntrantsTeamsPokerCompleted';
import SelectedTeamPokerCompleted from './SelectedTeam/SelectedTeamPokerCompleted';
import EntrantsTeamsGolfCompleted from './EntrantsTeams/EntrantsTeamsGolfCompleted';
import SelectedTeamGolfCompleted from './SelectedTeam/SelectedTeamGolfCompleted';
import EntrantsTeamsChessCompleted from './EntrantsTeams/EntrantsTeamsChessCompleted';
import SelectedTeamChessCompleted from './SelectedTeam/SelectedTeamChessCompleted';
import EntrantsTeamsEsportsCompleted from './EntrantsTeams/EntrantsTeamsEsportsCompleted';
import SelectedTeamEsportsCompleted from './SelectedTeam/SelectedTeamEsportsCompleted';
// Removed ParticipantsTable and EntrantsListTable imports
import BackButton from '../components/general/BackButton';
import ViewOwnershipModal from '../details/modals/ViewOwnershipModal';
import '../components/ContestInfo.css';

const ContestInfoCompleted = () => {
  const { id } = useParams();
  const { contest, loading, error } = useFetchContestDetails(id);
  // Add state for selected team and ref for scrolling
  const [selectedTeam, setSelectedTeam] = useState(null);
  const selectedTeamRef = useRef(null);
  const [showOwnershipModal, setShowOwnershipModal] = useState(false);
  // Removed accordion state

  // Effect to scroll to selected team
  useEffect(() => {
    if (selectedTeam && selectedTeamRef.current) {
      selectedTeamRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedTeam]);

  if (loading) {
    return (
      <div className="contest-loading-info">
        Loading Contest Information...
      </div>
    );
  }

  if (error) {
      return <div className="contest-loading-info">Error: {error.message || 'Could not load contest details.'}</div>;
  }

  if (!contest) {
    return (
      <div className="contest-loading-info">
        Contest details not found or ID was invalid.
      </div>
    );
  }

  // Get current username
  const currentUsername = localStorage.getItem('username');

  // Determine components based on sport
  let EntrantsTeamsComponent;
  let SelectedTeamComponent;

  switch (contest.sport) {
    case 'Golf':
      EntrantsTeamsComponent = EntrantsTeamsGolfCompleted;
      SelectedTeamComponent = SelectedTeamGolfCompleted;
      break;
    case 'Chess':
      EntrantsTeamsComponent = EntrantsTeamsChessCompleted;
      SelectedTeamComponent = SelectedTeamChessCompleted;
      break;
    case 'Esports':
      EntrantsTeamsComponent = EntrantsTeamsEsportsCompleted;
      SelectedTeamComponent = SelectedTeamEsportsCompleted;
      break;
    case 'Poker':
    default:
      EntrantsTeamsComponent = EntrantsTeamsPokerCompleted;
      SelectedTeamComponent = SelectedTeamPokerCompleted;
      break;
  }

  return (
    <div className="contest-details-container">
      <BackButton to="/contests/completed">
        ◄ Back to Completed Contests
      </BackButton>
      {contest && <ContestDetails contest={contest} showEnterButton={false} />}
      {/* Removed bar container and accordions */}
      {/* Render Entrants/Teams list */}
      <EntrantsTeamsComponent
        contest={contest}
        currentUsername={currentUsername}
        onTeamSelect={setSelectedTeam} // Pass handler to update state
      />
      {/* Render Selected Team view below */}
      <div ref={selectedTeamRef}>
        {selectedTeam && (
          <SelectedTeamComponent
            team={selectedTeam} // Pass selected team state
            contest={contest}
          />
        )}
      </div>
      <ViewOwnershipModal
        show={showOwnershipModal}
        onClose={() => setShowOwnershipModal(false)}
        players={contest.players}
        entrants={contest.entrants}
        currentUsername={currentUsername}
        contest={contest}
      />
    </div>
  );
};

export default ContestInfoCompleted;
